import React from 'react'
import PropTypes from 'prop-types'

const ContactIcon = props => {
  return props.active ? (
    <svg
      aria-hidden="true"
      className="navigation-icon active"
      width="77"
      height="60"
      viewBox="0 0 86 67"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Contact</title>
      <defs>
        <filter
          x="-54%"
          y="-87.1%"
          width="208%"
          height="274.2%"
          filterUnits="objectBoundingBox"
          id="contact_filter"
        >
          <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation="9" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" in="shadowBlurOuter1" />
        </filter>
        <path
          d="M65.143 45.126l-.297-.19a2292.226 2292.226 0 00-18.44-11.543l-.279-.171 19.016-11.421v23.325zm-40.81 1.18L43.482 34.81l.369.22c6.648 4.112 13.156 8.2 17.448 10.907l.58.367H24.334zm-3.475-24.908l.284.146c2.264 1.18 7.477 4.125 19.434 11.476l.285.171L20.858 45.2V21.398zm40.81-.703L43.506 31.603l-.103-.068c-7.725-4.754-13.598-8.28-17.46-10.467l-.654-.373h36.379zM18 49h50V18H18v31z"
          id="contact_path"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <use fill="#000" filter="url(#contact_filter)" href="#contact_path" />
        <use fill="#FFF" href="#contact_path" />
      </g>
    </svg>
  ) : (
    <svg
      aria-hidden="true"
      className="navigation-icon"
      width="77"
      height="60"
      viewBox="0 0 86 67"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Contact</title>
      <path
        d="M65.143 45.126l-.297-.19a2292.226 2292.226 0 00-18.44-11.543l-.279-.171 19.016-11.421v23.325zm-40.81 1.18L43.482 34.81l.369.22c6.648 4.112 13.156 8.2 17.448 10.907l.58.367H24.334zm-3.475-24.908l.284.146c2.264 1.18 7.477 4.125 19.434 11.476l.285.171L20.858 45.2V21.398zm40.81-.703L43.506 31.603l-.103-.068c-7.725-4.754-13.598-8.28-17.46-10.467l-.654-.373h36.379zM18 49h50V18H18v31z"
        fill="#FFF"
        fillRule="evenodd"
      />
    </svg>
  )
}

Window.propTypes = {
  active: PropTypes.string
}

export default ContactIcon
